import { useSessionContext } from '../context';

export function useSessionUpdates(): number {
	return useSessionContext().sessionUpdates;
}
